export const APP_NAME = 'Robinet Disco US';
export const API_URL = 'http://192.168.1.10:5000';
export const ICECAST_URL = 'http://192.168.1.10:8000/disco.m3u';


// WEBPACK FOOTER //
// ./src/lib/config.js